import React, { Component } from "react";
import { Link, withRouter  } from "react-router-dom";

export class ListTab extends Component {
    constructor(props) {
        super();
        this.state = {
            searchValue: null,
            selectedIndex: 0,
            tabValue: ""
        }
    }
 
    componentDidMount() {
        this.tabSelected();
        window.addEventListener("load", this.refreshPage);   
        this.getLabel();
    }

    componentWillUnmount() {
        window.removeEventListener("load", this.refreshPage);          
    }


    handleClick = (item) => {
        const { history } = this.props;

        if (!item.disable && item.href) {
            history.push(item.href);
        }
    };
    getLabel() {
        var tabActive = document.querySelectorAll(".request-table.data-table .list-tab.isSelectedTab");
        if(this.props.ontabSelected!==undefined && tabActive.length!==0)
        {
            this.props.ontabSelected(tabActive[0].innerText)   
        }   
    }
    refreshPage() {
        var tabSelected = document.querySelectorAll(".request-table.data-table .list-tab");
           if(tabSelected.length!==0)
           {
           /* tabSelected[0].classList.remove("isSelectedTab");         */  
            for (let i = 0; tabSelected.length > i; i++) {
                if(window.location.pathname.split("/").pop().split(/(?=[A-Z])/)[0].length===1)
                {
                    if (window.location.pathname.split("/").pop().split(" ").pop().includes(tabSelected[i].innerText.split(" ").pop())) {
                        tabSelected[i].classList.add("isSelectedTab");                       
                        break;
                     }
                } else {
                    var activeTab = tabSelected[i].childNodes[0].href.includes(window.location.pathname.split("/").pop());
                    if (activeTab) {
                        tabSelected[i].classList.add("isSelectedTab");                       
                        break;
                     }
                }               
                 if (window.location.pathname.split("/").pop().split(/(?=[A-Z])/)[0]==="Order") {
                    tabSelected[i].classList.add("isSelectedTab");                   
                    break;
                 }
               
             }

           }           
    }


    tabSelected() {
        const selectedTab = document.querySelectorAll(".list-tab");
        if(selectedTab.length!==0)
        {
           this.refreshPage();
            selectedTab.forEach((el) =>
                el.addEventListener("click", (event) => {
                    for (let i = 0; selectedTab.length > i; i++) {
                        selectedTab[i].classList.remove("isSelectedTab");
                    }
                    el.classList.add("isSelectedTab"); 
                    if(this.props.ontabSelected!==undefined)
                    {
                        this.props.ontabSelected(el.innerText)   
                    }                                  
                })
            );
        }       
    }


    render() {
        const { tabList, containerClassName, clickAction } = this.props;    
        
        return (
            <>
                {tabList!==undefined ? 
                <div className={containerClassName}>
                    <ul className="tab-list-container">
                        {tabList.map((item, id) => (
                            <li data-index={id} key={id} className="list-tab" onClick={() => this.handleClick(item)}>
                                {/*item.listTitle*/}
                                <Link className={item.disable ? "link-disabled" : ""} onClick={clickAction} to={item.href !== undefined ? item.href : "#"}>{item.listTitle} </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                
                : ""}                
            </>
        );
    }
}

export default withRouter(ListTab)